var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"layout"},[(!_vm.$route.meta.hideHeader)?_c('LayoutHead'):_vm._e(),(_vm.$route.meta.showBanner)?_c('LayoutBanner'):_vm._e(),(!_vm.$route.meta.hideBreadcrumb)?_c('LayoutBreadcrumb'):_vm._e(),_c('LayoutMain'),(!_vm.$route.meta.hideFooter)?_c('LayoutFooter'):_vm._e(),(!_vm.$route.meta.hideHeader)?_c('LayoutToolbar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }